import { motion } from "framer-motion";

const BEAMS = [
  { color: "#39FF14", top: "6%", angle: -16, dur: 5 },
  { color: "#B026FF", top: "24%", angle: -12, dur: 7 },
  { color: "#FF2E93", top: "42%", angle: -19, dur: 6 },
  { color: "#39FF14", top: "60%", angle: -13, dur: 8 },
  { color: "#B026FF", top: "78%", angle: -17, dur: 5.5 },
  { color: "#FF2E93", top: "92%", angle: -11, dur: 6.5 },
];

export default function Lasers({ className = "" }) {
  return (
    <div
      aria-hidden
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
    >
      {BEAMS.map((b, i) => (
        <motion.div
          key={i}
          animate={{ opacity: [0.2, 0.75, 0.2] }}
          transition={{
            duration: b.dur,
            repeat: Infinity,
            ease: "easeInOut",
            delay: i * 0.7,
          }}
          className="absolute left-1/2"
          style={{
            top: b.top,
            width: "150vmax",
            transform: `translateX(-50%) rotate(${b.angle}deg)`,
          }}
        >
          <div
            className="h-[7px] w-full rounded-full blur-[7px]"
            style={{ background: b.color }}
          />
          <div
            className="-mt-[4px] h-[2px] w-full rounded-full"
            style={{ background: b.color, boxShadow: `0 0 26px 2px ${b.color}` }}
          />
        </motion.div>
      ))}
    </div>
  );
}
